import {
  Box,
  Button,
  CircularProgress,
  Divider,
  IconButton,
  TextField,
  Typography
} from "@mui/material";
import React, { Fragment, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import AppBarHome from "../components/AppBar/Home";
import { getData } from "../libs/firebase/firestore/getData";
import { useNavigateToTop } from "../libs/useNavigateToTop";

import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import AddComment from '@mui/icons-material/AddComment';
import { Delete, Edit } from "@mui/icons-material";
import EditDecan from "../components/EditDecan";
import DeleteDecan from "../components/DeleteDecan";
import SpeciesSearch from "../components/SpeciesSearch";
import CommentDecan from "../components/CommentDecan";
import AppBarCreateGuide from "../components/AppBar/CreateGuide";
import { PDFDownloadLink } from "@react-pdf/renderer";
import GuidePdf from "../components/GuidePdf";
import { uploadData } from "../libs/firebase/firestore/uploadData";
import { getAllData } from "../libs/firebase/firestore/getAllData";

import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { getAuth } from "firebase/auth";
import LeafletMapGuideLocation from "../components/LeafletMapGuideLocation";
import BonsaiSoilComposition from "../components/BonsaiSoilComposition";
import { substrates } from "../libs/substrates";
import BonsaiStagesSelect from "../components/BonsaiStagesSelect";
import { updateData } from "../libs/firebase/firestore/updateData";
import AppBarEditGuide from "../components/AppBar/EditGuide";
// import { geoFire, geofireRef } from "../firebase";
// import { GeoFire } from "geofire";

// import PlantList from "../components/PlantList/List";
// import Root from "../components/PlantList/Root";

const bonsaiStages= [
  {
    name: "Development",
    description: "The first stage of bonsai development is to establish the primary structure of the tree. This includes the trunk, the first branches and the nebari (surface roots).",
    stageNumber: 1,
  },
  {
    name: "Structural",
    description: "The second stage of bonsai development is to establish the secondary branches and the secondary structure of the tree.",  
    stageNumber: 2,
  },
  {
    name: "Refinement",
    description: "The third stage of bonsai development is to refine the tertiary branches and the tertiary structure of the tree.",
    stageNumber: 3,
  },
]

const Stage = ({name, description, stageNumber, bonsaiGuide, setBonsaiGuide }) => {

  const stageProperty = "stage" + stageNumber;

  const handleSetSoilComposition = (newData) => {
    setBonsaiGuide({
      ...bonsaiGuide,
      soilComposition: newData,
    });
  }

  const handleSetSoilComment = (newComment) => {
    setBonsaiGuide({
      ...bonsaiGuide,
      soilComment: newComment,
    });
  }

  return (
    <Box>
      <BonsaiSoilComposition
        substrates={substrates}
        setSoilComposition={handleSetSoilComposition}
        soilComposition={bonsaiGuide.soilComposition}
        comment={bonsaiGuide.soilComment}
        setComment={handleSetSoilComment}
      />

      <Divider style={{ marginBottom: "2rem", marginTop:"2rem" }} />
      <Typography variant="h5" style={{ marginBottom: "1rem" }}>
          Calendar of Actions
        </Typography>

      <Typography variant="subtitle1" style={{ marginBottom: "1rem" }}>
        What time of year should things be done?
          </Typography>
          
        <Typography variant="subtitle1" style={{ marginBottom: "1rem" }}>
          
         Click and drag on the cells to add quickly.
          You can add rows to be more specific. For example you might have two fertilisation rows -  fertilise with 10:1:1 and fertilise with 4:1:1. Another example might be 1 row for structural pruning and another for defoliation.
          </Typography>
       {/* Stage 1 */}
       {/* <Typography variant="h5" style={{ marginBottom: "1rem" }}>
          {name}:
        </Typography>
        
        <Typography variant="subtitle1" style={{ marginBottom: "1rem" }}>
          {description}
          </Typography> */}
        <YearlyChart
        setData={(newData) => {
          setBonsaiGuide({
            ...bonsaiGuide,
            [stageProperty]: newData,
          });
        }
        }

        
         data={bonsaiGuide[stageProperty]}/>

        {/* Comments section from data */}
        <Box
          name="comments"
          id="comments"
        >
          <Typography variant="h6" marginTop={"1rem"}>Provide some details on the actions</Typography>
            <TextField
            // lines
                    rows={4}
                multiline
                fullWidth
                value={bonsaiGuide.yearlyChartComment}
                onChange={(e) =>
                  setBonsaiGuide({
                    ...bonsaiGuide,
                    yearlyChartComment: e.target.value,
                  })
                }
                placeholder="Enter your comments here"
            />

        {/* <Typography variant="h5" style={{marginTop:"1rem"}}>
          Comments
        </Typography>
        <Typography variant="subtitle1" style={{ marginBottom: "1rem" }}>
          The comments you add to each action will show here. This could be a description of the materials to use, when to do it, or a note on how to do it.
          </Typography>
          {bonsaiGuide[stageProperty].map((row) => {
            return (
              <Box>
                <Typography variant="h6">{row.name}</Typography>
                <Typography>{row.comment}</Typography>
              </Box>
            );
          }
          )}   
           */}
        </Box>   
    </Box>
  );

}

const YearlyChart = ({ data =[], setData }) => {

  //state last cell
  const [lastCell, setLastCell] = React.useState(null);
  const [cellsToHighlight, setCellsToHighlight] = React.useState([]);
  // state to hold if touch
  const [isTouch, setIsTouch] = React.useState(null);
  const colourCellTrue = "rgb(130, 147, 132)";
  const colourCellFalse = "white";
  const cellWidth = ".5rem";
  const cellHeight = "2rem";
  const cellPadding = "0rem";

  const numbers = [];
  for (let i = 1; i <= 36; i++) {
    numbers.push(i);
  }
  
  const months = [
    // just first three letters of the month
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  /**
   * A table. Each row is an element in the data array. The columns are the 12 months of the year, but with three columns per month. The colummn should be labeled with the month.
   */
 

  const handleCellClick = (rowIndex, columnIndex) => {
    let newData = [...data];
    // toggle the decan
    let row = newData[rowIndex];

    
    
    if (row.decans.includes(columnIndex)) {
      row.decans = row.decans.filter((dec) => dec !== columnIndex);
    }
    else {
      row.decans.push(columnIndex);
    }
    setData(newData);

  }

  const handleCellHover = (e, rowIndex, columnIndex) => {
    // if left mouse button is pressed run handleCellClick
    if (e.buttons === 1) {
      handleCellClick(rowIndex, columnIndex);
    }

  }

  const handleAddComment = (rowIndex) => {
    const newData = [...data];
    newData[rowIndex].comment = "Add comment here";
    setData(newData);
  }

  const handleEditDecan = (rowIndex, columnIndex) => {

  }

  const handleAddDecan = (rowIndex) => {
    // Add a whole new row to the data
    const newData = [...data];
    // add a new row just after the current row
    newData.splice(rowIndex + 1, 0, {
      name: `New ${newData[rowIndex].type}`,
      // type the same as the current row
      type: newData[rowIndex].type,
      decans: [],
      comment:""
    });
    setData(newData);
  }

  const handleDeleteDecan = (rowIndex) => {
    // only delete if there is more than one row of the same type
    if (data.filter((row) => row.type === data[rowIndex].type).length === 1) {
      return;
    }

    const newData = [...data];
    newData.splice(rowIndex, 1);
    setData(newData);


  }

  // const inputRef = useRef(null);


  useEffect(() => {
    // inputRef.current.addEventListener('onTouchMove',handleTouchMove, { passive: false });
    // return () => {
    //   inputRef.current.removeEventListener('onTouchMove',handleTouchMove);
    // }
  }
  ,[]);

  return (
        <TableContainer
        //force component to refresh
        
        >
          <Table
          // ref={inputRef}
          name="styledTable"
          id="styledTable"
          onTouchEnd={(e) => {
            return false;
            
          }}
          
          onTouchMove={(e) => {
            // get coordinates of the touch
            let touch = e.touches[0];
            let x = touch.clientX;
            let y = touch.clientY;

            let element = document.elementFromPoint(x, y);

            // if the element is a cell, run the handleCellClick function
            
            if (element){
              let cell = element;
              if (lastCell === cell){
                return;
              }
              // get row and column from key
              let key = cell.getAttribute("name");
              // console.log(cell)
              if (key){
                let [rowIndex, cellIndex] = key.split("-");

                // if is the first cell then ignore
                if (isTouch.row === rowIndex && isTouch.column === cellIndex){
                  return;
                }

                handleCellClick(parseInt(rowIndex), parseInt(cellIndex));
                // setCellsToHighlight([...cellsToHighlight, cell]);
                setLastCell(cell);
                // return false;
              }
              else {
                // no key
              }
            }
            // console.log(e)
          }}
          
        
          >
            <TableHead>
              <TableRow>
              <TableCell></TableCell>
                {months.map((month, index) => (
                    <TableCell 
                    key={index}
                    style={
                      {
                        textAlign: "center",
                        backgroundColor: "lightgrey",
                        // width: "6rem",
                        height: "2rem",
                        border: "1px solid black",
                    }
                  }
                    
                    colSpan={3}>{month}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row, rowIndex) => (
                <TableRow key={rowIndex}>
                  <TableCell

                  style={{
                    backgroundColor: "lightgrey",
                    width: "6rem",
                    height: "2rem",
                    border: "1px solid black",
                    textAlign: "center",
                    

                  }}
                  
                  
                  >

                  <Typography>
                    {row.name}
                  </Typography>
                {/* if type and name are the same then dont show type (do lowercase check and remove spaces) */}
                {row.name.toLowerCase().replace(" ","") === row.type.toLowerCase().replace(" ","") ? null : <Typography variant="subtitle2">{row.type}</Typography>}
                  {/* <IconButton onClick={() =>{handleEditDecan(index)}}><Edit/></IconButton> */}
                  <EditDecan data={row} saveData={(newName) => {row.name = newName; setData([...data])}}/>
                  {/* <CommentDecan data={row.comment} saveData={(newComment) => {row.comment = newComment; setData([...data])}}/> */}
                  <IconButton onClick={()=> {handleAddDecan(rowIndex)}}>+</IconButton>
                  {/* Delete */}
                  {data.filter((row) => row.type === data[rowIndex].type).length === 1 ? null : 
                  <DeleteDecan data={row} deleteData={() => {handleDeleteDecan(rowIndex)}}/>}
                  {/* a subtitle that shows the type */}
                  </TableCell>
                  {numbers.map((number,index) => (
                    <TableCell
                      key={rowIndex + "-" + number}
                    //name is index-number
                      name={rowIndex + "-" + number}
                      style={{
                        backgroundColor: row.decans.includes(number) ? colourCellTrue : colourCellFalse,
                        width: cellWidth,
                        height: cellHeight,
                        padding: cellPadding,
                        // border: "1px solid #F2F1EF",
                        // borderTop: "1px solid transparent",
                        // borderBottom: "1px solid transparent",
                        //if first column in the month, add a border to the left
                        borderLeft: number % 3 === 1 ? "1px solid black" : row.decans.includes(number) ? `1px solid ${colourCellTrue}` : "1px solid #D5D3CF",
                        // if third column in the month, add a border to the right
                        borderRight: number % 3 === 0 ? "1px solid black" : row.decans.includes(number) ? `1px solid ${colourCellTrue}` : "1px solid #D5D3CF",
                        // when hover make border
                        
                        touchAction: "none",
                        "&:active": {
                          border:"1px solid #E46540 !important",
                          borderLeft:"1px solid #E46540 !important",
                          cursor: "pointer",
                          touchAction: "none",
                        }
                        
                      }}
                      sx={{
                        "&:hover": {
                          border:"1px solid #E46540 !important",
                          borderLeft:"1px solid #E46540 !important",
                          cursor: "pointer",
                        },
                        //touchover
                        "&:active": {
                          border:"1px solid #E46540 !important",
                          borderLeft:"1px solid #E46540 !important",
                          cursor: "pointer",
                          touchAction: "none",
                        }
                      }}
                      onMouseDown={(e) =>{ 
                        // alert("mousedown")
                        // if touch then ignore
                        if (!isTouch) {
                          
                          handleCellClick(rowIndex, number);
                        }
                        else {
                          setIsTouch(null);
                        }

                        // handleCellClick(rowIndex, number)}}
                      }}
                      onMouseOver={(e) => {
                        
                        // alert("mouseOver")
                        handleCellHover(e,rowIndex, number)}}
                      onTouchStart={(e) => 
                        {
                          
                        //disable
                        setIsTouch({
                          row: rowIndex,
                          column: number,
                        });
                        handleCellClick(rowIndex, number)
                      }
                        }
                    >
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
            
            <TableHead>
              <TableRow>
              <TableCell></TableCell>
                {months.map((month,index) => (
                    <TableCell 
                    key={index}
                    style={
                      {
                        textAlign: "center",
                        backgroundColor: "lightgrey",
                        // width: "6rem",
                        height: "2rem",
                        border: "1px solid black",
                    }
                  }
                    
                    colSpan={3}>{month}</TableCell>
                ))}
              </TableRow>
            </TableHead>
          </Table>
        </TableContainer>
  );

}


function ScreenCreateGuide({bonsaiGuideData, guideId}) {

  const navigate = useNavigateToTop();

  // state to hold species
  const [species, setSpecies] = React.useState([]);
  
  const [tabContext, setTabContext] = React.useState('1');

  // state for is new species
  const [isNewSpecies, setIsNewSpecies] = React.useState(false);

  // state to hold guide data
  const [bonsaiGuide, setBonsaiGuide] = React.useState(()=> bonsaiGuideData || {
    upVotes:[],
    downVotes:[],
    commonName: "",
    scientificName: "",
    stage1: [
      {
        name: "Pruning",
        type: "pruning",
        decans:[],
      },
      {
        name: "Repotting",
        type: "repotting",
        decans:[],
      },
      {
        name: "Fertilizing",
        type: "fertilizing",
        decans:[],
      },
      {
        name: "Pest Control",
        type: "pestControl",
        decans:[],
      },
      {
        name: "Wire",
        type: "wire",
        decans:[],
      }
    ],
    stage2: [
      {
        name: "Pruning",
        type: "pruning",
        decans:[],
      },
      {
        name: "Repotting",
        type: "repotting",
        decans:[],
      },
      {
        name: "Fertilizing",
        type: "fertilizing",
        decans:[],
      },
      {
        name: "Pest Control",
        type: "pestControl",
        decans:[],
      },
      {
        name: "Wire",
        type: "wire",
        decans:[],
      }],
    stage3: [
      {
        name: "Pruning",
        type: "pruning",
        decans:[],
      },
      {
        name: "Repotting",
        type: "repotting",
        decans:[],
      },
      {
        name: "Fertilizing",
        type: "fertilizing",
        decans:[],
      },
      {
        name: "Pest Control",
        type: "pestControl",
        decans:[],
      },
      {
        name: "Wire",
        type: "wire",
        decans:[],
      }],

  });
  if (bonsaiGuideData){
    if (bonsaiGuideData.commonName !== bonsaiGuide.commonName || bonsaiGuideData.scientificName !== bonsaiGuide.scientificName)
    setBonsaiGuide(bonsaiGuideData);
  }
  // if guide is empty obeject {} then reutnr null
  

  
  const currentUser = getAuth().currentUser;

  const handleTabChange = (event, newValue) => {
    setTabContext(newValue);
  };

  const handleOnSave = () => {

    //Save to firebase
    let guide = {
      userId: currentUser.uid,
      timeDateCreated: new Date(),
      isNewSpecies: isNewSpecies,
      ...bonsaiGuide
    };

    uploadData(
      guide,
      "bonsai-guides",
      () => {
        navigate("/");
      },
      (error) => {
        console.log(error);
      }
    );
  }

  const handleOnEditSave = () => {
    //Save to firebase
    let guide = {
      ...bonsaiGuide,
      timeDateCreated: new Date(),
    };
    if (guide.geo.latitude === undefined){
      guide.geo = {
        latitude: bonsaiGuideData.geo.latitude,
        longitude: bonsaiGuideData.geo.longitude,
      }
    }

    updateData(
      guide,
      `bonsai-guides`,
      guideId,
      () => {
        navigate("/");
      },
      (error) => {
        console.log(error);
      }
    );
  }



  useEffect(() => {
    getAllData("species", (speciesData) => {
      setSpecies(speciesData);
    });
  }, []);

  const pdfName= `${bonsaiGuide.commonName} - ${bonsaiGuide.scientificName} ${bonsaiGuide.stage || ""} Guide.pdf`


const canSave = bonsaiGuide.commonName !== "" && bonsaiGuide.scientificName !== "" ;
const canExport = canSave;

 let mapCenterLat = bonsaiGuide.latitude || 51.505;
  let mapCenterLng = bonsaiGuide.longitude || -0.09;
  let mapCenter = [mapCenterLat, mapCenterLng];

  return (
    <Box
      key={
        bonsaiGuideData ? bonsaiGuideData.userId : "new"
      }
    >
      {bonsaiGuideData ?(
      <AppBarEditGuide
        onSave={handleOnEditSave}
        canSave={canSave}
      />) : (
      <AppBarCreateGuide
        onSave={handleOnSave}
        canSave={canSave}
      />
      )}

      <Box
        style={{
          padding: "2rem",
          margin: "auto 0",
        }}
      > 
      
      <Typography variant="h5" style={{ marginBottom: "1rem" }}>
         What species is this for?
        </Typography>
        {(!bonsaiGuideData  &&
      <SpeciesSearch
        species={species}
        setSpecies={setSpecies}
          onSelect={(species, isNew =false) => {
            if (species === null) {
              return;
            }
            setBonsaiGuide({
              ...bonsaiGuide,
              commonName: species.commonName,
              scientificName: species.scientificName,
            });
            setIsNewSpecies(isNew);
          }}
        
        />
        )}
        {bonsaiGuide.commonName === "" && bonsaiGuide.scientificName === "" ? null : (
        <Typography variant="h4" style={{  marginTop:"1rem" }}>
         {bonsaiGuide.commonName}
          
          <span style={{ fontStyle: "italic", fontSize:"1.2rem" }}>
            - {bonsaiGuide.scientificName}
          </span>
        </Typography>
        )}

        <Divider style={{ marginBottom: "1rem", marginTop:"1rem" }} />
        <Typography variant="h5" style={{ marginBottom: "1rem" }}>
          Where does this guide apply?
        </Typography>
        <Typography variant="subtitle1" style={{ marginBottom: "1rem" }}>
          Use the map to roughly show where this guide applies. If it won't move, try zooming in first.
        </Typography>
        <LeafletMapGuideLocation
        center={
          mapCenter
        }
        onViewChanged={(center) => {
          const geo = {
            latitude: center.lat,
            longitude: center.lng
          }
          // const geohash= geoFire.geohashForLocation([center.lat, center.lng]);
          setBonsaiGuide({
            ...bonsaiGuide,
            geo,
            latitude: center.lat,
            longitude: center.lng,
            // geohash: geohash
          });
        }}
        
        />

        
        <Divider style={{ marginBottom: "2rem", marginTop:"2rem" }} />
        
        
        <Typography variant="h5" style={{ marginBottom: "1rem" }}>
          Stages of Bonsai
        </Typography>
        
        <Typography variant="subtitle1" style={{ marginBottom: "1rem" }}>
          Bonsai go through different stages in their life. Each stage has different goals and requires different care. Which stage of life would you like this guide to be about? 
        </Typography>
        <BonsaiStagesSelect
          stage={bonsaiGuide.stage || ""}
          handleStageChange={(event) => {
            setBonsaiGuide({
              ...bonsaiGuide,
              stage: event.target.value,
            });
          }}
        />
        
        <Divider style={{ marginBottom: "2rem", marginTop:"2rem" }} />
          <Stage
          name={bonsaiStages[0].name}
          description={bonsaiStages[0].description}
          stageNumber={bonsaiStages[0].stageNumber}
          bonsaiGuide={bonsaiGuide}
          setBonsaiGuide={setBonsaiGuide}
          />

          <Divider style={{ marginBottom: "2rem", marginTop:"2rem" }} />
          <Typography variant="h5" style={{ marginBottom: "1rem" }}>
            Guide as a PDF
            </Typography>
            <Typography variant="subtitle1" style={{ marginBottom: "1rem" }}>
              Export the guide to as an A3 PDF. This will allow you to print it out and put in on your wall.
            </Typography>
      <PDFDownloadLink
      style={{
        // float: "right",
      }}
        document={<GuidePdf guide={bonsaiGuide} />}
        fileName={pdfName}
      >
        {({ blob, url, loading, error }) => (
        <Button variant="contained" color="secondary"
          disabled={!canExport}
        >
          Export to PDF
        </Button>
      )}
      </PDFDownloadLink> 
      {/* Save the guide */}
      <Divider style={{ marginBottom: "2rem", marginTop:"2rem" }} />
      <Typography variant="h5" style={{ marginBottom: "1rem" }}>
        Save the Guide
        </Typography>
        <Typography variant="subtitle1" style={{ marginBottom: "1rem" }}>
          Save the guide to your account. You can come back and edit it later.
        </Typography>
        <Button

          variant="contained"
          color="primary"
          onClick={
            bonsaiGuideData ? handleOnEditSave : handleOnSave
          }
          disabled={!canSave}
        >
          Save Guide
        </Button>


    {/* <Box sx={{ width: '100%', typography: 'body1' }}>
      <TabContext value={tabContext}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList onChange={handleTabChange} aria-label="lab API tabs example">
            <Tab label="Development" value="1" />
            <Tab label="Structural (1st, 2nd branching)" value="2" />
            <Tab label="Refinement (Tertiary branching)" value="3" />
          </TabList>
        </Box>
        <TabPanel value="1">

          <Stage
          name={bonsaiStages[0].name}
          description={bonsaiStages[0].description}
          stageNumber={bonsaiStages[0].stageNumber}
          bonsaiGuide={bonsaiGuide}
          setBonsaiGuide={setBonsaiGuide}
          />
        </TabPanel>
        <TabPanel value="2">
          <Stage
          name={bonsaiStages[1].name}
          description={bonsaiStages[1].description}
          stageNumber={bonsaiStages[1].stageNumber}
          bonsaiGuide={bonsaiGuide}
          setBonsaiGuide={setBonsaiGuide}

          />
        </TabPanel>
        <TabPanel value="3">
          <Stage
          name={bonsaiStages[2].name}
          description={bonsaiStages[2].description}
          stageNumber={bonsaiStages[2].stageNumber}
          bonsaiGuide={bonsaiGuide}
          setBonsaiGuide={setBonsaiGuide}
          />
        </TabPanel>
      </TabContext>
    </Box> */}

       
        
      </Box>
    </Box>
  );
}

export default ScreenCreateGuide;
